import React from "react";
import { base44 } from "../api/base44Client";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, User, Share2 } from "lucide-react";
import { motion } from "framer-motion";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

export default function BlogPost() {
  const urlParams = new URLSearchParams(window.location.search);
  const postId = urlParams.get('id');

  const { data: post, isLoading } = useQuery({
    queryKey: ['blog-post', postId],
    queryFn: async () => { const posts = await base44.entities.BlogPost.list(); return posts.find(p => p.id === postId); },
    enabled: !!postId
  });

  if (isLoading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-16 w-16 border-b-2 border-black"></div></div>;
  if (!post) return <div className="min-h-screen flex items-center justify-center"><div className="text-center"><p className="text-xl text-gray-600 mb-4">Article non trouvé</p><Link to="/blog"><button className="accent-gradient text-white px-6 py-2 rounded-lg">Retour au blog</button></Link></div></div>;

  const categoryLabels = { actualites:"Actualités", conseils:"Conseils", projets:"Projets", temoignages:"Témoignages" };

  return (
    <div className="min-h-screen bg-gray-50">
      <article>
        <section className="gradient-bg text-white py-12">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Link to="/blog"><button className="mb-6 bg-white/10 text-white border border-white/20 px-4 py-2 rounded-lg hover:bg-white/20 flex items-center gap-2"><ArrowLeft className="w-4 h-4" />Retour au blog</button></Link>
            <motion.div initial={{ opacity:0,y:20 }} animate={{ opacity:1,y:0 }}>
              {post.category && <span className="inline-block bg-[#c41e3a] text-white px-4 py-1 rounded-full text-sm font-bold mb-4">{categoryLabels[post.category]}</span>}
              <h1 className="text-4xl md:text-5xl font-bold mb-6">{post.title}</h1>
              <div className="flex items-center gap-6 text-gray-200">
                <div className="flex items-center gap-2"><Calendar className="w-5 h-5" /><span>{format(new Date(post.created_date),'dd MMMM yyyy',{locale:fr})}</span></div>
                <div className="flex items-center gap-2"><User className="w-5 h-5" /><span>{post.created_by}</span></div>
              </div>
            </motion.div>
          </div>
        </section>

        {post.featured_image && (
          <section className="py-8">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden shadow-xl rounded-xl"><img src={post.featured_image} alt={post.title} className="w-full h-96 object-cover" /></div>
            </div>
          </section>
        )}

        <section className="py-8">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="border-none shadow-xl p-8 md:p-12 rounded-xl bg-white">
              <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed whitespace-pre-wrap">{post.content}</div>
            </div>
            <div className="mt-8 flex items-center justify-center gap-4">
              <span className="text-gray-600 font-medium">Partager cet article :</span>
              <button className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50"><Share2 className="w-4 h-4" /></button>
            </div>
          </div>
        </section>
      </article>
    </div>
  );
}
